import { createApp, h } from 'vue'
import App from './App.vue'
import singleSpaVue from 'single-spa-vue'
import router from './router'
import createVuetifyPlugin from './plugins/vuetify.js'
import i18n from './locales/i18n.js'
import { createPinia } from 'pinia'
import pkg from '../package.json'

let singleSpaProps = {}

// Calculate mfName and keyName from props, with fallback for shared configs
const getMfConfig = (props) => {
  const mfName = props.name || pkg.name || 'unknown-microfrontend'
  const keyName = `${mfName}-config`
  
  // Try specific key first, then fallback to shared config (e.g., demf-kpim-editor-config for all editor MFs)
  let config = props[keyName]
  
  if (!config) {
    // Extract shared prefix (e.g., "demf-kpim-editor" from "demf-kpim-editor-summary")
    const sharedKeyMatch = mfName.match(/^(demf-[^-]+-[^-]+)-/)
    if (sharedKeyMatch) {
      const sharedKey = `${sharedKeyMatch[1]}-config`
      config = props[sharedKey]
    }
  }
  
  return { mfName, keyName, config: config || {} }
}

const vueLifecycles = singleSpaVue({
  createApp,
  appOptions: {
    render() {
      const { config } = getMfConfig(singleSpaProps)

      return h(App, {
        singleSpaProps,
        mfConfig: config,
        palette: singleSpaProps.palette,
        realm: singleSpaProps.realm,
      })
    }
  },
  handleInstance: (app, props) => {
    singleSpaProps = props

    const { mfName, keyName, config } = getMfConfig(props)
    console.log(`Mounted ${mfName} v${pkg.version}`)
    
    if (config && Object.keys(config).length > 0) {
      console.log(`✅ Config loaded from: ${props[keyName] ? keyName : 'shared config'}`)
    }

    // Configure Vuetify with the palette received from props
    const vuetify = createVuetifyPlugin(props.palette || {}, i18n)
    app.use(vuetify)
    app.use(router)
    app.use(i18n)
    app.use(createPinia())
  }
})

export const bootstrap = vueLifecycles.bootstrap
export const mount = vueLifecycles.mount
export const unmount = vueLifecycles.unmount
